import {DEFAULT_BRUSH,type BrushKind,type BrushSettings} from './brush';
import {DEFAULT_SHAPE,type DrawingShape} from './drawingShapes';
import type {ShadowStyle} from './drawingShadow';
export type DrawingSetupKey=BrushKind|'shapes';
export interface DrawingSetup {width:number;opacity:number;shadow:ShadowStyle}
/** Private ready setups are independent from the single authored raster/history. */
export class DrawingSetupMemory {
 private entries=new Map<DrawingSetupKey,DrawingSetup>();
 private shape:DrawingShape={...DEFAULT_SHAPE};
 rememberShape(shape:DrawingShape){this.shape={...shape};}
 getShape():DrawingShape{return {...this.shape};}
 remember(key:DrawingSetupKey,settings:Pick<BrushSettings,'width'|'opacity'>,shadow:ShadowStyle){this.entries.set(key,{width:settings.width,opacity:settings.opacity,shadow});}
 get(key:DrawingSetupKey):DrawingSetup{return this.entries.get(key)??{width:DEFAULT_BRUSH.width,opacity:DEFAULT_BRUSH.opacity,shadow:'off'};}
}
